// Imports
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BBService } from 'bookingbug-core-js';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Globals } from '../../globals';
// Services
import { DataStoreService } from '../../services';


@Component({
  selector: 'app-location-page',
  templateUrl: './location-page.component.html',
  styleUrls: ['./location-page.component.css']
})
export class LocationPageComponent implements OnInit {
  companyChildren = [];
  locationList = [];
  turnaroundText;
  turnaroundTextIrish;
  turnaroundInfoText;
  turnaroundInfoTextIrish;
  globals: Globals;
  loadIssue: boolean;

  constructor(
    private spinner: NgxSpinnerService,
    globals: Globals,
    private DataStore: DataStoreService,
    private router: Router,
    private _cookieService: CookieService
  ) {
    this.globals = globals;
  }

  ngOnInit() {
    // delete all inputted data
    this.DataStore.parentID = 37000;
    delete this.DataStore.clientDetails;
    delete this.DataStore.applicationDetails;
    delete this.DataStore.applicantArray;
    delete this.DataStore.applicantArrayCopy;
    delete this.DataStore.bookingQuestion;
    delete this.DataStore.dynamicForm;
    this.DataStore.servicesAvailibility = [];
    this.DataStore.basketItems.length = 0;

    this.spinner.show();
    BBService.company.query(this.DataStore.parentID, { excludeChildCompanies: false }).then(parentCompany => {

      this.turnaroundText = [
        parentCompany.extra.location_page_text,
        parentCompany.extra.location_page_text_2
      ].filter(Boolean).join('\n');

      this.turnaroundTextIrish = [
        parentCompany.extra.location_page_irish_text,
        parentCompany.extra.location_page_irish_text_2,
      ].filter(Boolean).join('\n');

      this.turnaroundInfoText = [
        parentCompany.extra.location_page_fee_schedule,
        parentCompany.extra.location_page_fee_schedule_2,
      ].filter(Boolean).join('\n');

      this.turnaroundInfoTextIrish = [
        parentCompany.extra.location_page_fee_schedule_irish_text,
        parentCompany.extra.location_page_fee_schedule_irish_text_2,
      ].filter(Boolean).join('\n');


      parentCompany.$getChildren().then(children => {
        this.companyChildren = [...children];
      }).then(() => {
        this.companyChildren.forEach((child, i) => {
          let resourcesDisabled = false;
          let peopleDisabled = false;
          this.locationList.push(child);

          child.$getPeople().then(response => {
          }).catch((error: HttpErrorResponse) => {
            if (error['response'].status === 404) {
              child.notBookable = true;
            }
            this.spinner.hide();
          });
          child.$getResources().then(resources => {
            resources.length === 0 ? child.notBookable = true : null;
          }).catch((error: HttpErrorResponse) => {
            if (error['response'].status === 404) {
              child.notBookable = true;
            }
            this.spinner.hide();
          });

          if (peopleDisabled || resourcesDisabled) {
            child.notBookable = true;
          } else {
            child.notBookable = false;
          }

          child.$getServices().then(services => {
            this.locationList[i].services = [];
            this.locationList[i].filteredServices = [];
            const filteredServices = services.filter(service => service.name.includes('Four-Day') && !service.name.toLowerCase().includes('walk-in') || service.name.includes('Five-Day') && !service.name.toLowerCase().includes('walk-in') || service.name.includes('Same-Day') && !service.name.toLowerCase().includes('walk-in'));
            this.locationList[i].services.push(...services);
            this.locationList[i].filteredServices.push(...filteredServices);
          });
          this.spinner.hide();
        });
      }, (err) => {
        this.loadIssue = true;
        this.spinner.hide();
      });
    }, (err) => {
      this.loadIssue = true;
      this.spinner.hide();
    });
  }

  selectLocation(location) {
    this.DataStore.selectedLocation = location;
    // Filter out the walk in services
    const filteredServices = location.services.filter(service => service.name.toLowerCase().includes('four-day') && !service.name.toLowerCase().includes('walk-in') || service.name.toLowerCase().includes('five-day') && !service.name.toLowerCase().includes('walk-in') || service.name.toLowerCase().includes('same-day') && !service.name.toLowerCase().includes('walk-in') || service.name.toLowerCase().includes('emergency'));
    this.DataStore.selectedLocation.services = filteredServices;

    this.DataStore.irishAddress = location.extra.irish_address ? location.extra.irish_address.split(',') : '';
    this.DataStore.selectedLocationID = location.id;
    this.router.navigate(['/booking-details']);
  }
}
